import classNames from 'classnames'

const Pager = ({ isDisabled, isChevron, onClick, children, customClass = '' }) => {
  let options = {
    class: classNames(
      `control-pagination--pager-item`,
      isDisabled ? 'disabled' : null,
      isChevron ? 'chevron' : null,
      customClass
    ),
    onClick: !isDisabled ? onClick : null
  }
  return <div {...options} >{children}</div>
}

export default Pager
